import dom from '../../../wrapper/DomWrapper';

export default (sectionHash) => {
  const { hash } = dom.window.location;

  if (hash === sectionHash) return;

  dom.window.location.hash = sectionHash;
};
